import { render } from "./Searchbar.vue?vue&type=template&id=a87cfffc&scoped=true"
import script from "./Searchbar.vue?vue&type=script&lang=js"
export * from "./Searchbar.vue?vue&type=script&lang=js"

import "./Searchbar.vue?vue&type=style&index=0&id=a87cfffc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87cfffc"]])

export default __exports__